import { Voucher } from "@/shared/core-vouchers";
import { z } from "zod";
import { voucherSchema } from "./schemas/voucherSchema";
import { DefaultValues } from "react-hook-form";

export const getDefaultValues = (
  voucher?: (Voucher & { zone: string }) | null,
): DefaultValues<z.infer<typeof voucherSchema>> => {
  return {
    voucherDate: voucher ? new Date(voucher.voucherDate) : new Date(),
    voucherType: voucher
      ? {
          value: voucher.voucherType.id,
          label: voucher.voucherType.name,
        }
      : undefined,
    zone: voucher?.zone ?? undefined,
    storage: voucher
      ? {
          value: voucher.storage.id,
          label: voucher.storage.name,
        }
      : undefined,
    workOrder: voucher?.workOrder
      ? {
          value: voucher.workOrder.id,
          label: voucher.workOrder.name,
        }
      : undefined,
    costCenter: voucher
      ? {
          value: voucher?.costCenter?.id,
          label: voucher?.costCenter?.name,
        }
      : undefined,
    productApplicant: voucher
      ? {
          value: voucher.productApplicant.id,
          label: voucher.productApplicant.name,
        }
      : undefined,
    clientEntity: voucher
      ? {
          value: voucher.clientEntity.id,
          label: voucher.clientEntity.name,
        }
      : undefined,
    activityLabel: voucher
      ? {
          value: voucher.activityLabel.id,
          label: voucher.activityLabel.label,
        }
      : undefined,
    equipmentInstance: voucher?.equipmentInstance
      ? {
          value: voucher.equipmentInstance?.id,
          label: voucher.equipmentInstance?.code,
        }
      : undefined,
    comment: voucher?.comment || "",
    products: voucher
      ? voucher.products.map((product) => ({
          id: product.id,
          amount: product.voucherProduct?.amount,
          missingStock: product.voucherProduct?.missingStock || 0,
          comment: product.voucherProduct?.comment || "",
        }))
      : [],
  };
};
